module.exports = __webpack_public_path__ + "img/Head-Right-Side@2x.71ab606c.png";